import React from 'react';
import { PrimaryCamper, AgeCategory } from '../../../types/camper';
import './PrimaryCamperForm.css';

interface PrimaryCamperFormProps {
  onSubmit: (data: Partial<PrimaryCamper>) => Promise<void>;
  initialData?: Partial<PrimaryCamper>;
  isEditing?: boolean;
}

const PrimaryCamperForm: React.FC<PrimaryCamperFormProps> = ({
  onSubmit,
  initialData = {},
  isEditing = false
}) => {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log('PrimaryCamperForm handleSubmit triggered');
    
    const formData = new FormData(e.currentTarget);
    const data: Partial<PrimaryCamper> = {
      FirstName: formData.get('FirstName') as string,
      LastName: formData.get('LastName') as string,
      Age: formData.get('Age') as AgeCategory,
      email: formData.get('email') as string,
      HomePhone: formData.get('HomePhone') as string,
      MobilePhone: formData.get('MobilePhone') as string,
      Street: formData.get('Street') as string,
      Town: formData.get('Town') as string,
      Province: formData.get('Province') as string,
      PostalCode: formData.get('PostalCode') as string,
      LicensePlate: formData.get('LicensePlate') as string,
    };
    
    console.log('Form data collected:', JSON.stringify(data));
    console.log('Is editing mode:', isEditing);
    
    try {
      console.log('Calling onSubmit function...');
      await onSubmit(data);
      console.log('onSubmit function completed successfully');
    } catch (error) {
      console.error('Error in form submission:', error);
      alert('Failed to save camper. Please check console for details.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="contact-camper-form">
      <h2>Contact Camper</h2>
      
      <div className="form-grid">
        <div className="form-field">
          <label htmlFor="FirstName">First Name</label>
          <input
            type="text"
            id="FirstName"
            name="FirstName"
            defaultValue={initialData.FirstName || ''}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="LastName">Last Name</label>
          <input
            type="text"
            id="LastName"
            name="LastName"
            defaultValue={initialData.LastName || ''}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="Age">Age Category</label>
          <select
            id="Age"
            name="Age"
            defaultValue={initialData.Age || AgeCategory.Adult}
            required
          >
            <option value={AgeCategory.Adult}>Adult</option>
            <option value={AgeCategory.AdultStudent}>Adult Student</option>
            <option value={AgeCategory.YouthChildren}>Youth/Children</option>
          </select>
        </div>

        <div className="form-field">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            defaultValue={initialData.email || ''}
            required
          />
        </div>

        <div className="form-field">
          <label>Login Status</label>
          <div className={`login-status ${initialData.loginExists ? 'has-login' : 'no-login'}`}>
            {initialData.loginExists ? 'Has Login Account' : 'No Login Account'}
          </div>
        </div>

        <div className="form-field">
          <label htmlFor="HomePhone">Home Phone</label>
          <input
            type="tel"
            id="HomePhone"
            name="HomePhone"
            defaultValue={initialData.HomePhone || ''}
          />
        </div>

        <div className="form-field">
          <label htmlFor="MobilePhone">Mobile Phone</label>
          <input
            type="tel"
            id="MobilePhone"
            name="MobilePhone"
            defaultValue={initialData.MobilePhone || ''}
          />
        </div>

        <div className="form-field full-width">
          <label htmlFor="Street">Street Address</label>
          <input
            type="text"
            id="Street"
            name="Street"
            defaultValue={initialData.Street || ''}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="Town">Town/City</label>
          <input
            type="text"
            id="Town"
            name="Town"
            defaultValue={initialData.Town || ''}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="Province">Province</label>
          <input
            type="text"
            id="Province"
            name="Province"
            defaultValue={initialData.Province || ''}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="PostalCode">Postal Code</label>
          <input
            type="text"
            id="PostalCode"
            name="PostalCode"
            defaultValue={initialData.PostalCode || ''}
            required
          />
        </div>

        <div className="form-field">
          <label htmlFor="LicensePlate">License Plate</label>
          <input
            type="text"
            id="LicensePlate"
            name="LicensePlate"
            defaultValue={initialData.LicensePlate || ''}
          />
        </div>
      </div>

      <button type="submit" className="submit-button">
        {isEditing ? 'Save Changes' : 'Create Camper'}
      </button>
    </form>
  );
};

export default PrimaryCamperForm; 